<template>
  <Popup v-model="rule.show" class="myrule" :close-on-click-overlay="false">
    <button class="close" @click="close"></button>
    <div class="rule-content">
      <h2>活动规则</h2>
      <div class="text" v-html="rule.text"></div>
    </div>
  </Popup>
</template>
<script>
import { Popup } from 'vant'
export default {
  components: {
    Popup
  },
  props: {
    rule: {
      type: Object
    }
  },
  data () {
    return {
      ruleShow: true
    }
  },
  methods: {
    close () {
      this.$emit('ruleClose')
    }
  }
}
</script>
<style lang='less' scoped>
.myrule {
  background: none;
  width: 6rem;
  .close {
    width: 0.47rem;
    height: 0.46rem;
    background: url(./img/close.png) no-repeat;
    background-size: 100% auto;
    position: absolute;
    top: 0;
    right: 0;
    display: block;
  }
  .rule-content {
    margin-top: 0.8rem;
    border-radius: 0.2rem;
    background: #fffcf9;
    padding-top: 0.3rem;
    h2 {
      width: 2rem;
      line-height: 0.64rem;
      height: 0.64rem;
      background: #ff6633;
      border-radius: 0.32rem;
      text-align: center;
      margin: 0 auto;
      font-size: @fz32;
      color: #fff;
    }
    .text {
      height: 6rem;
      overflow-y: scroll;
      margin: 0.4rem 0.3rem 0.2rem 0.3rem;
      font-size: @fz24;
      color: #2d2d3e;
      line-height: 0.38rem;
    }
  }
}
</style>
